import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ExamTopicTree from './ExamTopicTree';
import PracticeSetsModal from './PracticeSets/PracticeSetsModal';
import StudentVouchersModal from './StudentVoucherComponent/StudentVouchersModal';
import './Dashboard.css';
import './ExamTopicTree.css';

function UpcomingExams({ studentId }) {
  const navigate = useNavigate();

  const [selection, setSelection] = useState({
    examId: '',
    examName: '',
    subjectId: '',
    subjectName: '',
    topicId: '',
    topicName: ''
  });

  const [practiceModalOpen, setPracticeModalOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);

  // Trigger re-render of ExamTopicTree when vouchers are activated
  const [refreshCounter, setRefreshCounter] = useState(0);

  // Track whether exams exist
  const [hasExams, setHasExams] = useState(false);

  const handleSelectionChange = (newSelection) => {
    setSelection(newSelection);
  };

  const handleOpenPracticeModal = (ids) => {
    setSelectedNode(ids); // { examId, subjectId, topicId }
    setPracticeModalOpen(true);
  };

  const handleVoucherActivated = () => {
    setRefreshCounter(prev => prev + 1); // forces ExamTopicTree to re-fetch active exams
  };

  // Optional: control StudentVouchersModal visibility
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);

  return (
    <div className="upcomingExamSection">
      <h2 className="sectionTitle">📅 Upcoming Exams</h2>

      {/* Exam Tree */}
      <ExamTopicTree
        studentId={studentId}
        onSelectionChange={handleSelectionChange}
        onPracticeClick={handleOpenPracticeModal}
        refresh={refreshCounter}
        onExamsLoaded={(count) => setHasExams(count > 0)}  // ✅ update exam availability
      />

      {/* Practice Sets Modal */}
      {practiceModalOpen && selectedNode && (
        <PracticeSetsModal
          open={practiceModalOpen}
          onClose={() => setPracticeModalOpen(false)}
          examId={selectedNode.examId}
          subjectId={selectedNode.subjectId}
          topicId={selectedNode.topicId}
        />
      )}

      {/* Student Vouchers Modal */}
      {voucherModalOpen && (
        <StudentVouchersModal
          studentId={studentId}
          visible={voucherModalOpen}
          onClose={() => setVoucherModalOpen(false)}
          onVoucherActivated={handleVoucherActivated}
        />
      )}

      {/* Message if no exams */}
      {!hasExams && (
        <p style={{ fontSize: '0.9rem', color: 'gray' }}>
          No upcoming exams available. Please activate a voucher to unlock exams.
        </p>
      )}
    </div>
  );
}

export default UpcomingExams;
